module.exports = __webpack_public_path__ + "img/pro-spatial-analysis.73b732ac.webp";